"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocTypeEnum = exports.DocVersionEnum = exports.PaymentPeriodFilter = exports.MotorCoverTier = exports.AnnualPolicyPremiumTypeEnum = exports.PolicyPropertyEnum = exports.PartyPropertyEnum = exports.ProductNameEnum = exports.SessionStorageItemEnum = exports.ProductIdEnum = exports.ProductsEnum = exports.IncludedProductsEnum = void 0;
var IncludedProductsEnum;
(function (IncludedProductsEnum) {
    IncludedProductsEnum[IncludedProductsEnum["WOLF_MOTOR"] = 4] = "WOLF_MOTOR";
    // Next products should be added with following values: 8,16,32,64...
})(IncludedProductsEnum || (exports.IncludedProductsEnum = IncludedProductsEnum = {}));
var ProductsEnum;
(function (ProductsEnum) {
    ProductsEnum["WOLF_MOTOR"] = "AnnualMotorInsurance";
    ProductsEnum["DRIVE_AWAY"] = "DriveAwayInsurance";
})(ProductsEnum || (exports.ProductsEnum = ProductsEnum = {}));
var ProductIdEnum;
(function (ProductIdEnum) {
    ProductIdEnum[ProductIdEnum["WOLF_MOTOR"] = 3] = "WOLF_MOTOR";
})(ProductIdEnum || (exports.ProductIdEnum = ProductIdEnum = {}));
var SessionStorageItemEnum;
(function (SessionStorageItemEnum) {
    SessionStorageItemEnum["ADDRESS_CHANGED"] = "FalconAddressChanged";
    SessionStorageItemEnum["ADDRESS_CHANGE_REFERER"] = "FalconAddressChangeReferer";
    SessionStorageItemEnum["SESSION_STORAGE_EVENT_WARNING_PAGE_SHOWN"] = "eventWarningPageShown";
})(SessionStorageItemEnum || (exports.SessionStorageItemEnum = SessionStorageItemEnum = {}));
var ProductNameEnum;
(function (ProductNameEnum) {
    ProductNameEnum["WOLF_MOTOR"] = "ANNUAL_MOTOR";
})(ProductNameEnum || (exports.ProductNameEnum = ProductNameEnum = {}));
var PartyPropertyEnum;
(function (PartyPropertyEnum) {
    PartyPropertyEnum["CARS_IN_HOUSEHOLD"] = "carsInHousehold";
    PartyPropertyEnum["SEND_DOCUMENTS_BY_EMAIL"] = "sendDocumentsByEmail";
    PartyPropertyEnum["SEND_DOCUMENTS_BY_POST"] = "sendDocumentsByPost";
    PartyPropertyEnum["MARKETING_PREFERENCES_EMAIL"] = "marketingPreferencesEmail";
    PartyPropertyEnum["MARKETING_PREFERENCES_PHONE"] = "marketingPreferencesPhone";
    PartyPropertyEnum["MARKETING_PREFERENCES_POST"] = "marketingPreferencesPost";
    PartyPropertyEnum["MARKETING_PREFERENCES_SMS"] = "marketingPreferencesSMS";
    PartyPropertyEnum["MOVED_TO_ADDRESS"] = "movedToAddress";
    PartyPropertyEnum["OWNS_HOME"] = "ownsHome";
    PartyPropertyEnum["CUSTOMER_LV_MEMBER"] = "customerLVMember";
    PartyPropertyEnum["HAS_UNSPENT_CRIMINAL_CONVICTIONS"] = "hasUnspentCriminalConvictions";
    PartyPropertyEnum["BUSINESS_USE"] = "businessUse";
    PartyPropertyEnum["LAST_VRN_CHANGE_DATE_TEMPLATE"] = "lastVehicleRegistrationNumberChangeDateForPolicy%d";
    PartyPropertyEnum["BILLING_ADDRESS_CHANGE_ALLOWED"] = "billingAddressChangeAllowed";
    PartyPropertyEnum["VULNERABLE_CUSTOMER"] = "vulnerableCustomer";
    PartyPropertyEnum["ACTIVE_VULNERABLE_CUSTOMER_ACTION"] = "activeVulnerableCustomerAction";
})(PartyPropertyEnum || (exports.PartyPropertyEnum = PartyPropertyEnum = {}));
var PolicyPropertyEnum;
(function (PolicyPropertyEnum) {
    PolicyPropertyEnum["REUSE_MAIN_CARD"] = "reuseMainCard";
    PolicyPropertyEnum["POLICY_DEBT"] = "policyDebt";
    PolicyPropertyEnum["AUTOMATIC_RENEWAL"] = "automaticRenewal";
    PolicyPropertyEnum["PERFORM_RENEWAL"] = "performRenewal";
    PolicyPropertyEnum["SUPPRESS_RENEWAL"] = "suppressRenewal";
    PolicyPropertyEnum["MAIN_ANNUAL_PAYMENT_CARD"] = "mainAnnualPaymentCard";
    PolicyPropertyEnum["ANNUAL_MONTHLY_OPTION_CARD_EXPIRED"] = "annualMonthlyOptionCardExpired";
    PolicyPropertyEnum["MODIFIED_PAYMENT_DAY"] = "modifiedPaymentDay";
})(PolicyPropertyEnum || (exports.PolicyPropertyEnum = PolicyPropertyEnum = {}));
var AnnualPolicyPremiumTypeEnum;
(function (AnnualPolicyPremiumTypeEnum) {
    AnnualPolicyPremiumTypeEnum["ANNUAL"] = "annual";
    AnnualPolicyPremiumTypeEnum["MONTHLY"] = "monthly";
})(AnnualPolicyPremiumTypeEnum || (exports.AnnualPolicyPremiumTypeEnum = AnnualPolicyPremiumTypeEnum = {}));
var MotorCoverTier;
(function (MotorCoverTier) {
    MotorCoverTier["ALLIANZ_ESSENTIALS"] = "ALLIANZ_ESSENTIALS";
    MotorCoverTier["ALLIANZ"] = "ALLIANZ";
})(MotorCoverTier || (exports.MotorCoverTier = MotorCoverTier = {}));
var PaymentPeriodFilter;
(function (PaymentPeriodFilter) {
    PaymentPeriodFilter["CURRENT"] = "CURRENT";
    PaymentPeriodFilter["PAST"] = "PAST";
})(PaymentPeriodFilter || (exports.PaymentPeriodFilter = PaymentPeriodFilter = {}));
var DocVersionEnum;
(function (DocVersionEnum) {
    DocVersionEnum["V1"] = "v1";
    DocVersionEnum["V2"] = "v2";
})(DocVersionEnum || (exports.DocVersionEnum = DocVersionEnum = {}));
var DocTypeEnum;
(function (DocTypeEnum) {
    DocTypeEnum["DOI"] = "DOI";
    DocTypeEnum["IPID_PLUS"] = "IPID_Plus";
    DocTypeEnum["IPID_ESSENTIALS"] = "IPID_Essentials";
    DocTypeEnum["MLE"] = "MLE";
    DocTypeEnum["DRIVE_AWAY_DOI"] = "DriveAway_DOI";
    DocTypeEnum["DRIVE_AWAY_IPID"] = "DriveAway_IPID";
})(DocTypeEnum || (exports.DocTypeEnum = DocTypeEnum = {}));
//# sourceMappingURL=enums.js.map